//—— 一次提問 → 聊天串裡的兩則訊息 ——
//
//  從頁面抽出來獨立一支，有兩個理由（同 fuyaozi-messages）：
//    1. 它是純資料轉換，沒有 JSX 也沒有狀態 —— 抽出來就能拿資料庫裡
//       真實的提問直接跑一遍，不必先起一個瀏覽器。
//    2. 三條路徑都要用它（載入歷史、剛問完那一題、輪詢補上的回答）。
//       各寫一份的話「歷史看到的」跟「剛問完看到的」會長得不一樣。
//
//  不另外存一份訊息：問題在扣券的當下就寫進 Question、回答生成完也寫回
//  同一筆文件，聊天串本來就是那張表 —— 再存一份就是同一件事有兩個真相。

//—— 作答失敗時白夜說的話 ——
//
//  券已經扣了，要講清楚「問題收到了、只是這次看不出來」，
//  不要讓他以為整件事沒發生過。語氣跟他平常一致，不要變成系統錯誤訊息。
//
//  分成兩種，因為該講的完全不一樣：
//    還會再試  後端會自動補跑五次（見 utils/recovery-sweeper），
//              所以要說「等我」而不是「算了」—— 他什麼都不用做。
//    放棄了    補跑用完了，而**券不退**。這時唯一的出路是找客服，
//              所以要把編號給他 —— 沒有編號的話客服查不到是哪一筆。
export const RETRYING_TEXT =
  "你這一問我收下了，只是此刻看不真切。我再看一回，你稍後回來。";

export const givenUpText = (id) =>
  `你這一問我收下了，卻始終看不真切，是我的不是。\n拿這個記號找客服，他們會替你補上：${id}`;

export const hasAnswer = (q) => Boolean(String(q?.answer || "").trim());

//—— 一題擱多久就當它不會好了 ——
//
//  背景生成實測約 7.5 秒，輪詢本身也只撐 30 秒（15 次 × 2 秒）。
//  三分鐘還沒有回答，代表那支背景任務在某個地方死掉了（程序被回收、
//  模型回了不合格的東西、例外被吞掉），再問一百次也不會變出來。
//
//  **這條界線是必要的，不是保險。** 沒有它的話，每次進頁面都會對所有
//  擱置的提問各輪詢 15 次 —— 累積十幾筆就是兩百多支註定失敗的請求
//  （問卦那邊真的發生過）。
export const ANSWER_STALE_MS = 3 * 60 * 1000;

export const isPending = (q) =>
  !hasAnswer(q) &&
  !q.givenUp &&
  q.status !== "failed" &&
  Date.now() - Number(q.createdAt || 0) < ANSWER_STALE_MS;

//白夜那一則。三種狀態各一種樣子。
//
//  還在生成時給的 id 是 `pending-<編號>` —— 輪詢拿到回答之後就是靠它
//  找到該換掉哪一則（見頁面的 fillAnswer）。
export const masterMessage = (q) => {
  const id = q.questionID;

  if (hasAnswer(q)) {
    return { id, role: "master", text: q.answer };
  }

  //  還在跑。給 typing 而不是一句「容我細看片刻」——
  //  提問是一問一答的對話，對話裡「對方正在輸入」就是三個點，
  //  講一句話反而像他已經回答了（而那不是回答）。
  if (isPending(q)) {
    return { id: `pending-${id}`, role: "master", typing: true };
  }

  //  到這裡就是這一輪沒有回答。兩種情況分開講（見上面那兩段文案）：
  //  放棄了才給編號與客服，還會再試的只要請他等。
  return {
    id,
    role: "master",
    text: q.givenUp ? givenUpText(id) : RETRYING_TEXT,
  };
};

export const questionMessages = (q) => [
  { id: `q-${q.questionID}`, role: "user", text: q.question },
  masterMessage(q),
];
